<template>
  <div class="contact">
    <div class="content">
      <p>Address: 3 FRASER STREET #05-25 DUO TOWER SINGAPORE(189352)</p>
      <p>Postcode: 189352</p>
      <p>Phone: +65 87499389</p>
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="less" scoped>
  .contact{
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .content{
      padding: .12rem;
    }
  }
</style>
